class FormValidator {
  constructor(settings) {
    this.options = Object.assign({
      formsClass: '.form-class',
      fieldsClass: '.element-validation',
      errorClass: 'error',
      submitButton: '*[type=submit]',
      disableSubmit: false
    }, settings);


    this.forms = document.querySelectorAll(this.options.formsClass);
    this.forms.forEach(form => {
      if (form) {
        this.validateOnEntry(form);

        if (this.options.disableSubmit) {
          const submitWrapper = form.querySelector(this.options.submitButton);
          this._hideSubmit(form, true);
          //if click by disabled button
          submitWrapper.addEventListener('click', (e) => {
            const formFields = form.querySelectorAll(this.options.fieldsClass);
            formFields.forEach(field => {
              this.validateFields(field);
            });
          });
        } else {
          this.formSubmit(form);
        }
      }
    });
  }

  _hideSubmit(form, status) {
    const event = status ? "none" : "auto";
    form.querySelector(this.options.submitButton).style.pointerEvents = event;
  }

  formSubmit(form) {
    form.addEventListener('submit', e => {
      form.querySelectorAll(this.options.fieldsClass).forEach(field => {
        //if validation after submit return false - e.preventDefault() and stopping submitting form
        if (!this.validateFields(field, form)) {
          e.preventDefault();
        }
      })
    });
  }


  validateOnEntry(form) {
    //all validate fields in this form
    const formFields = form.querySelectorAll(this.options.fieldsClass);
    formFields.forEach(field => {
      field.addEventListener('input', event => {
        this.validateFields(field);
        if (this.options.disableSubmit) {
          this.validForm(form);
        }
      })
    });
  }


  validForm(parentForm) {
    //check form for errors + empty fields
    let allFields = parentForm.querySelectorAll(this.options.fieldsClass)
    let emptyFields = [...allFields].filter(input => input.value == "");
    let errorFields = parentForm.querySelectorAll(`.${this.options.errorClass}`);

    if (errorFields.length || emptyFields.length) {
      this._hideSubmit(parentForm, true)
    } else {
      this._hideSubmit(parentForm, false)
    }
  }

  validateFields(field) {
    // check for a valid email address
    if (field.type === "email") {
      if(field.value.length > 3) {
        const re = /\S+@\S+\.\S+/
        if(re.test(field.value)) {
          this.setStatus(field, "success")
          return true
        } else {
          this.setStatus(field, "error")
          return false
        }
      }
    }

    //check telephone
    if (field.type === "tel") {
      const re = /^[0-9]{6,}$/
      if (re.test(field.value)) {
        this.setStatus(field, "success")
        return true
      } else {
        this.setStatus(field, "error")
        return false
      }
    }

    //checkbox validation
    if (field.type === "checkbox") {
      if (field.checked) {
        this.setStatus(field, "success")
        return true
      } else {
        this.setStatus(field, "error")
        return false
      }
    }

    // Check presence of values
    /*if (field.value.trim() === "") {
      this.setStatus(field, "error")
      return false
    } else {
      this.setStatus(field, "success")
      return true
    }*/
  }

  setStatus(field, status) {
    if (status === "success") {
      field.closest('.newsletter-form__field-wrapper').classList.remove(this.options.errorClass)
      return true
    }

    if (status === "error") {
      field.closest('.newsletter-form__field-wrapper').classList.add(this.options.errorClass)
      return false
    }
  }
}

const newsletter = new FormValidator({
  formsClass: '.newsletter-form',
  fieldsClass: '.field__input',
  disableSubmit: true
});
